import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { InformePagosHeaderToolbar } from "./InformePagosHeaderToolbar";

export const InformePagosHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <InformePagosHeaderToolbar />
            </div>
        </div>
    )
}